const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
if (nonceMeta) {
  const val = nonceMeta.getAttribute('content');
  window.__webpack_nonce__ = val;
  __webpack_nonce__ = val;
}